import type { Messages } from "@prop/i18n";
import type en from "../en/landing";

export default {
  brand: "Funded Lime",
  buy: "Начать челлендж",
  nav: { programs: "Программы", execution: "Исполнение", docs: "Документы", faq: "Вопросы", cabinet: "Кабинет", signIn: "Войти", start: "Открыть счёт", language: "Язык", menu: "Меню" },
  hero: {
    titleA: "Выжми",
    titleB: "весь рынок",
    year: "(’26)",
    about: "(О нас)",
    aboutText: "Симуляция проп-деска на реальных рыночных данных. Каждый ордер встречает живой стакан в момент поступления и исполняется за 10–30 мс.",
    badge: "Политика v{v}",
    avail1: "Исполнение за 10–30 мс",
    avail2: "без добавленной задержки",
    outNow: "Уже работает",
    outTitle: "Крипто 24/7",
    outTag: "[Онлайн]",
    feed: "Поток движка",
    markets: "Рынки",
    sources: "Рыночные данные в реальном времени · крипто · FX · индексы",
    live: "Онлайн из движка",
    title: "Проп-трейдинг на настоящем движке",
    lead: "Каждый ордер исполняется в момент поступления по живому стакану, а у каждого исполнения сохраняется снимок рынка. Крипто круглосуточно, FX и фьючерсы CME.",
    primary: "Выбрать программу",
    secondary: "Создать аккаунт",
    btc: "BTC, последняя сделка",
    latency: "Добавленная задержка, p50",
    fills: "Исполнений за 7 дней",
    policy: "Политика исполнения",
    tape: "Последние сделки",
    ms: "{v} мс",
  },
  bar: { since: "С", year: "2026", scroll: "Листайте вниз", live: "Живой стакан" },
  statement: {
    text: "Мы не продаём мечту. Мы продаём честное исполнение: каждый ордер встречает живой стакан, у каждого исполнения есть чек, а купленные правила заморожены хешем.",
    sub: "Симулированные счета на реальных рыночных данных.",
    subMuted: "Для тех, кто читает ленту.",
  },
  slogans: {
    s1: "Самое время начать",
    s2: "Самое время измениться",
    s3: "Торгуй по плану, а не по надежде",
    s4: "Дисциплина — это свобода",
    s5: "Малый риск, длинная игра",
    s6: "Заработай свой капитал",
  },
  quotes: {
    money: { text: "Деньги приходят за дисциплиной. Никогда не наоборот.", by: "— Правило деска" },
    start: { text: "Каждый трейдер с капиталом когда-то был новичком, который не сдался.", by: "— Правило деска" },
  },
  board: {
    title: "Исполнение у всех на виду",
    lead: "Считается по снимку рынка, который движок сохраняет у каждого исполнения, за последние 7 дней. Ничего не отбирается и не правится.",
    live: "Онлайн",
    updated: "Обновлено в {time}",
    fills: "Исполнений за 7 дней",
    accounts: "торгующих счетов",
    latency: "Добавленная задержка, p50 / p99",
    quoteAge: "Возраст котировки при исполнении, p50 / p99",
    walked: "Исполнений по видимому стакану",
    policy: "Политика исполнения",
    lastFill: "Последнее исполнение в {time}",
    ms: "{a} / {b} мс",
    withheld: "За период слишком мало исполнений, чтобы публиковать цифры.",
    loading: "Загрузка…",
    receipt: "У каждого исполнения есть чек",
    receiptLead: "«Почему здесь» у любого исполнения: стакан, mark, последняя сделка, возраст котировки, задержка, модель исполнения и версия политики.",
  },
  spec: {
    title: "Выберите свою оценку",
    lead: "Все параметры — до оплаты. Купленные правила замораживаются, у них есть хеш.",
    market: "Рынок",
    markets: { crypto: "Крипто-перпы", fx: "FX и металлы", futures: "Фьючерсы CME" },
    desc: {
      crypto: "Перпы BTC, ETH и SOL на живых рыночных данных. Стакан не закрывается.",
      fx: "EUR/USD, GBP/USD, USD/JPY и золото. День заканчивается в 17:00 по Нью-Йорку.",
      futures: "ES, NQ, CL и GC в сессию CME.",
    },
    steps: "Оценка",
    step1: "1 этап",
    step2: "2 этапа",
    size: "Размер счёта",
    fee: "Стоимость оценки",
    target: "Цель по прибыли",
    dll: "Дневной лимит убытка",
    ml: "Максимальный убыток",
    days: "Мин. торговых дней",
    split: "Доля трейдера",
    dayEnds: "Конец торгового дня",
    version: "Версия правил",
    oneTime: "разово",
    perMonth: "/ мес.",
    yourTime: "{time} по вашему времени",
    select: "Начать с {size}",
    footnote: "Стартовые цены. Новая версия правил действует только для новых покупок.",
    none: "Для такого сочетания программы пока нет.",
  },
  platform: {
    title: "Терминал, сделанный под этот деск",
    lead: "График, стакан, лента сделок и тикет, который считает объём от вашего риска. На живых рыночных данных.",
    f1: { t: "Живой стакан и лента", d: "Глубина и каждая сделка в момент печати." },
    f2: { t: "Объём от риска", d: "Задайте риск в долларах, остальное посчитает тикет." },
    f3: { t: "Стопы вместе со входом", d: "Тейк-профит и стоп-лосс уходят вместе с ордером." },
    f4: { t: "«Почему здесь»", d: "Рынок в момент каждого исполнения." },
    caption: "Терминал на живых рыночных данных.",
  },
  how: {
    title: "От оценки до выплаты",
    s1: { line: "Выберите программу", note: "Крипто, FX или фьючерсы CME. Одна цена, одни правила, замороженные при покупке." },
    s2: { line: "Торгуйте живой стакан", note: "Реальные цены и глубина; рыночный ордер проходит по стакану." },
    s3: { line: "Достигните цели по правилам", note: "Дневной и максимальный убыток проверяются на каждом тике по equity." },
    s4: { line: "Получите до 90%", note: "После проверки, на проверенный кошелёк, с подтверждением двух сотрудников." },
  },
  docs: {
    title: "Прочитайте до начала торговли",
    lead: "Всё, что управляет вашим счётом, записано, версионировано и открыто.",
    execution: { name: "Политика исполнения", meta: "v1.3 · исполнение по всему стакану, комиссия 0,75 % + 0,25 % за плечо, x1–x30" },
    rules: { name: "Правила программ", meta: "Версии · SHA-256 у каждой" },
    risk: { name: "Раскрытие рисков", meta: "Симулированная торговля, без доступа к реальному рынку" },
    terms: { name: "Условия использования", meta: "Плата за оценку, funded-этап, выплаты, KYC" },
    payouts: { name: "Политика выплат", meta: "Когда и как funded-счёт платит" },
    refunds: { name: "Платежи и возвраты", meta: "Оплата криптовалютой, возврат до первой сделки" },
    prohibited: { name: "Запрещённые практики", meta: "Хедж, мультиаккаунт, копирование, арбитраж" },
    privacy: { name: "Конфиденциальность и cookie", meta: "Что храним и зачем; только необходимые cookie" },
    open: "Открыть",
  },
  faq: {
    title: "Вопросы",
    real: { q: "Это реальные деньги?", a: "Торговля симулированная: счета виртуальные, ордера исполняет наш движок по реальным рыночным данным. Оплата — настоящая, как и выплаты на funded-аккаунтах: их платит компания из своих средств по правилам программы." },
    fills: { q: "Как исполняются мои ордера?", a: "По опубликованной политике исполнения (v1.3): без добавленной задержки — ордер встречает живой стакан сразу и исполняется за 10–30 мс. Рыночный ордер проходит весь стакан: с каждого уровня ему доступна только пятая часть видимого объёма, остаток исполняется за стаканом по всё худшей цене, а спред шире исходной котировки — крупный ордер платит реальное проскальзывание, на спреде не заработать. Комиссии: 0,75 % от объёма за сторону и 0,25 % за плечо; плечо x1–x30 на ваш выбор. «Почему здесь» есть у каждого исполнения." },
    day: { q: "Когда заканчивается мой торговый день?", a: "Это указано в программе: 00:00 UTC для крипто, 17:00 Нью-Йорка для FX, сессия CME для фьючерсов. Карточка программы показывает это по вашему времени." },
    rules: { q: "Могут ли правила измениться после покупки?", a: "Нет. Аккаунт остаётся на купленной версии программы с её хешем. Новая версия действует только для новых покупок." },
    feed: { q: "Что если упадёт поток данных?", a: "Инструмент со сбоем данных никогда не нарушает аккаунт: решение ждёт, пока поток снова не станет живым, а короткий ценовой выброс отфильтровывается." },
    payouts: { q: "Как устроены выплаты?", a: "Когда счёт funded и личность подтверждена, вы запрашиваете выплату на кошелёк, прошедший санкционную проверку. Один сотрудник готовит выплату, другой подтверждает." },
  },
  cta: {
    title: "Самое время начать",
    lead: "Выберите программу, прочитайте все правила и откройте счёт за несколько минут.",
    primary: "Выбрать программу",
    secondary: "Создать аккаунт",
  },
  pics: {
    engine: "Визуализация ядра движка исполнения",
    terminal: "Терминал: живой график BTC, живой стакан, лента сделок, тикет",
    fill: "Исполнение со снимком рынка: модель, задержка, возраст котировки, mark, последняя сделка и стакан",
  },
  footer: {
    risk: "Раскрытие рисков. Все счета симулированные, ни один ордер не попадает на реальный рынок. Результат оценки не предсказывает результат реальной торговли. Выплаты на funded-счетах производятся из собственных средств компании по правилам программы.",
    note: "Оплата криптовалютой. Аккаунт откроется, как только платёж подтвердится.",
    top: "Наверх",
    contact: "hello@fundedlime.com",
    credits: "Графики: собственный движок · рыночные данные: биржевые потоки в реальном времени · изображения сгенерированы",
    year: "2026",
  },
} satisfies Messages<typeof en>;
